module.exports = __webpack_public_path__ + "img/img_32389_0_480.b4fc434c.png";